import type React from 'react'

type Props = {
  size?: number
}

const IconLeft: React.FC<Props> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.17578 14.7617C8.08789 14.8203 8 14.8496 7.91211 14.8496C7.79492 14.8496 7.73633 14.8203 7.67773 14.7617L1.55469 8.60938C1.4668 8.55078 1.4375 8.49219 1.4375 8.375C1.4375 8.28711 1.4668 8.19922 1.55469 8.14062L7.67773 1.98828C7.73633 1.92969 7.79492 1.90039 7.91211 1.90039C8 1.90039 8.08789 1.92969 8.17578 1.98828L8.76172 2.57422C8.82031 2.63281 8.84961 2.7207 8.84961 2.80859C8.84961 2.92578 8.82031 3.01367 8.76172 3.07227L4.2207 7.61328H14.2109C14.2988 7.61328 14.3867 7.67188 14.4453 7.73047C14.5039 7.78906 14.5625 7.87695 14.5625 7.96484V8.78516C14.5625 8.90234 14.5039 8.99023 14.4453 9.04883C14.3867 9.10742 14.2988 9.13672 14.2109 9.13672H4.2207L8.76172 13.6777C8.82031 13.7656 8.84961 13.8535 8.84961 13.9414C8.84961 14.0586 8.82031 14.1172 8.76172 14.1758L8.17578 14.7617Z"
      fill="currentColor"
    />
  </svg>
)

export default IconLeft
